module.exports = __webpack_public_path__ + "img/ideias-e-acoes.b8ae0a75.jpg";